
var $body,
  $loadMore,
  $postGrid,
  currentPage = 0,
  paginationOffset;


$(document).ready(function($) {

  $loadMore = $('.js-load-more');
  $postGrid = $('.js-post-grid');

  paginationOffset = $loadMore.data('paginationOffset');

  $loadMore.click(function(event) {
    event.preventDefault();

    if(!$(this).hasClass('is-loading')) {
      $(this).addClass('is-loading');
      lazyLoadNextPage();
    }
  });


  function lazyLoadNextPage(action) {
    var nextPage = currentPage + 1;

    jQuery.ajax({
      url : linku_ajax_url,
      type : 'post',
      data : {
        action : 'lazy_load',
        page : nextPage,
        offset: paginationOffset
      },
      dataType: 'json',
      success : function( response ) {
        currentPage++;

        if(! response.meta.has_next) {
          $loadMore.remove();
        }

        $postGrid.append(response.html);
        $loadMore.removeClass('is-loading');
      }
    });
  }
});


// Functions